import { Box, Skeleton, Stack, useTheme } from "@mui/material";
import { WhiteBox } from "@foodpilot/foods";

const PostSkeleton = () => {
    const theme = useTheme();

    return (
        <WhiteBox sx={{ mb: 2, overflow: "hidden" }}>
            <Stack direction="row" alignItems="stretch">
                <Skeleton variant="rectangular" width={4} sx={{ borderRadius: "4px 0 0 4px", minHeight: 200 }} />
                <Stack flex={1} sx={{ p: 2 }} gap={2}>
                    <Stack direction="row" alignItems="center" gap={2}>
                        <Skeleton variant="circular" width={theme.spacing(5)} height={theme.spacing(5)} />
                        <Box flex={1}>
                            <Skeleton variant="text" width={150} height={20} />
                            <Skeleton variant="text" width={100} height={16} />
                        </Box>
                        <Skeleton variant="rounded" width={88} height={28} />
                    </Stack>

                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="text" width="60%" height={20} />

                    <Stack direction="row" gap={1}>
                        <Skeleton variant="rounded" width={60} height={24} />
                        <Skeleton variant="rounded" width={80} height={24} />
                    </Stack>

                    <Stack direction="row" justifyContent="space-around" gap={1}>
                        <Skeleton variant="rounded" width={72} height={36} sx={{ borderRadius: 999 }} />
                        <Skeleton variant="rounded" width={96} height={36} sx={{ borderRadius: 999 }} />
                        <Skeleton variant="rounded" width={72} height={36} sx={{ borderRadius: 999 }} />
                    </Stack>
                </Stack>
            </Stack>
        </WhiteBox>
    );
};

export const FeedSkeleton = () => {
    return (
        <Box>
            {Array.from({ length: 3 }).map((_, index) => (
                <PostSkeleton key={index} />
            ))}
        </Box>
    );
};
